<template>
  <v-col
    cols="12"
    class="d-flex"
    style="flex-direction: column; height: 100%"
  >
    <v-card
      class="rounded-0 pa-7"
      elevation="0"
      id="HoraireInscriptions"
    >
      <v-card-title class="titreBoite"> {{$tc('accueil.BoiteInscriptionLigne.Titre')}} </v-card-title>
      <br />

      <!--Boite 1 -->
      <!-- Section 1 -->
      <v-card
        class="boite-cours-suivants carte-timeline-haut borderBleuSansBottom"
        color="#095797"
        dark
      >
        <!-- Premiere boite blanche -->
        <div v-html="appStore.texteDynamique.BlocTexte8">
        </div>
      </v-card>

      <v-timeline
  class="timeline-full-height"
        align-top
        dense
        line-inset="0"
      >
        <!--Premiere date bleue -->
        <v-timeline-item
          color="#095797"
          icon="mdi-pencil"
          fill-dot
        >
          <v-card
            class="carte-timeline-bas borderBleuSansTop"
            color="#095797"
            dark
          >
            <v-card-title
              class="titreTimeLine"
              v-html="appStore.texteDynamique.BlocTexte9"
            >
            </v-card-title>

            <div v-html="appStore.texteDynamique.BlocTexte10">
            </div>

          </v-card>
        </v-timeline-item>
        <br />
        <!-- Deuxieme date bleue -->
        <v-card
          class="boite-autres-cours carte-timeline-haut borderBleuSansBottom"
          color="#095797"
          dark
        >
          <div v-html="appStore.texteDynamique.BlocTexte11">
          </div>
        </v-card>

        <v-timeline-item
          color="#095797"
          icon="mdi-pencil"
          fill-dot
        >
          <v-card
            class="carte-timeline-bas borderBleuSansTop"
            color="#095797"
            dark
          >
            <v-card-title
              class="titreTimeLine"
              v-html="appStore.texteDynamique.BlocTexte12"
            >
            </v-card-title>
            <div v-html="appStore.texteDynamique.BlocTexte13">
            </div>

          </v-card>
        </v-timeline-item>
        <br />
        <!--Boite 2 -->
        <!-- Section 1 -->
        <v-card
          class="boite-autres-cours carte-timeline-haut borderBleuSansBottom"
          color="#095797"
          dark
        >
          <div v-html="appStore.texteDynamique.BlocTexte14">
          </div>
        </v-card>

        <!--Section 2 -->
        <v-timeline-item
          color="#095797"
          icon="mdi-pencil"
          fill-dot
        >
          <v-card
            class="carte-timeline-bas borderBleuSansTop"
            color="#095797"
            dark
          >
            <v-card-title
              class="titreTimeLine"
              v-html="appStore.texteDynamique.BlocTexte15"
            >
            </v-card-title>
            <div v-html="appStore.texteDynamique.BlocTexte16">
            </div>
          </v-card>
        </v-timeline-item>

        <br />

        <!-- Boite 3 -->
        <v-timeline-item
          color="#009FE3"
          icon="mdi-star"
          fill-dot
        >
          <v-card
            color="#009FE3"
            dark
            class="borderBleuSansTopPale"
          >
            <v-card-title
              class="titreTimeLine"
              v-html="appStore.texteDynamique.BlocTexte17"
            >
            </v-card-title>
            <div v-html="appStore.texteDynamique.BlocTexte18">
            </div>
          </v-card>
        </v-timeline-item>
      </v-timeline>
    </v-card>
    <v-divider style="background-color: black"></v-divider>
    <v-card
      class="rounded-0 pa-10"
      elevation="0"
      style="height: 100%"
    >
      <div v-html="appStore.texteDynamique.BlocTexte19">
      </div>

      <div v-html="appStore.texteDynamique.BlocTexte20">
      </div>

    </v-card>
  </v-col>
</template>

<script>
import useAppStore from '@/store/appStore';

export default {
  name: 'BoiteInscriptionLigne',
  setup() {
    const appStore = useAppStore();

    return { appStore };
  },
  data() {
    return {
    };
  },
  created() {

  },
  methods: {
  },
  computed: {
  },
};
</script>

<style scoped>
.carte-timeline-haut {
  border-radius: 4px 4px 0 0;
}

.carte-timeline-milieu {
  border-radius: 0;
}

.carte-timeline-bas {
  border-radius: 0 0 4px 4px;
}

.boite-cours-suivants {
  max-width: calc(100% - 96px);
  margin: 0 0 -24px 96px;
}

.boite-autres-cours {
  max-width: calc(100% - 96px);
  margin-left: 96px;
}

.timeline-full-height {
  min-height: 100%;
}

.borderBleuSansBottom {
  border-right: 2px solid rgb(9, 87, 151);
  border-top: 2px solid rgb(9, 87, 151);
  border-left: 2px solid rgb(9, 87, 151)
}

.borderBleuLeftRight {
  border-right: 2px solid rgb(9, 87, 151);
  border-left: 2px solid rgb(9, 87, 151)
}

.borderBleuSansTop {
  border-right: 2px solid rgb(9, 87, 151);
  border-left: 2px solid rgb(9, 87, 151);
  border-bottom: 2px solid rgb(9, 87, 151)
}

.borderBleuSansTopPale {
  border-right: 2px solid rgb(0, 159, 227);
  border-left: 2px solid rgb(0, 159, 227);
  border-bottom: 2px solid rgb(0, 159, 227);
}
</style>
